import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import styles from './ScrollToTopButton.module.css';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    const toggleVisibility = () => {
        // Since many pages use a scrollable .main-content div instead of window
        // we check both.
        const mainContent = document.querySelector('main');
        const scrollPos = mainContent ? mainContent.scrollTop : window.pageYOffset;

        if (scrollPos > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        const mainContent = document.querySelector('main');
        if (mainContent) {
            mainContent.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        // Listen to scroll events on both window and the main-content areas
        window.addEventListener('scroll', toggleVisibility);
        
        // Use a mutation observer or a periodic check because the main element 
        // might be replaced during navigation
        const interval = setInterval(toggleVisibility, 500);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
            clearInterval(interval);
        };
    }, []);

    return (
        <div className={`${styles['scroll-to-top']} ${isVisible ? styles['show'] : ''}`} onClick={scrollToTop}>
            <button aria-label="Scroll to top">
                <ArrowUp size={24} />
            </button>
        </div>
    );
};

export default ScrollToTopButton;
